<template>
  <div
    class="item-box-content"
    style="padding-bottom:20px;"
  >
    <div class="title-font-style">
      <span>合同总览</span>
    </div>
    <!-- class="details-line-height" -->
    <el-form
      style="padding:10px 10px 0 30px;"
      label-position="left"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="合同编号：">{{ params.pcbNumber }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商：">
            <span
              @click="suIdClick(params.spId)"
              class="approval"
            >{{ params.suName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="供应商合同编号："
            label-width="120px"
            style="line-height:30px;"
          >
            <el-input
              @change="supplierContractNumber"
              v-model="params.supplierContractNumber"
              v-show="$route.query.type === '待审核'"
            ></el-input>
            <span v-show="$route.query.type !== '待审核'">
              {{
              params.supplierContractNumber||'--'
              }}
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="合同金额：">
            {{
            params.purchaseTotal|priceFilterNum
            }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="已付账款：">
            {{
            params.actualTotal|priceFilterNum
            }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="应付账款：">
            {{
            params.accountsPayable|priceFilterNum
            }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="已到期应付账款：">
            {{
            params.accountsDue|priceFilterNum
            }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="未到期应付账款：">
            {{
            params.accountsOutstanding|priceFilterNum
            }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="合同状态：">
            <span style="color:#60C96D">
              {{
              params.contractState | contractState
              }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="签订时间：">
            {{
            params.signTime | dateFilterl
            }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发货方式：">{{ params.sendType }}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="当前负责人：">
            {{
            params.staffUsename
            }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="更新时间：">
            {{
            params.updateDate | dateFilterl
            }}
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if='params.stockupType === "直发备货"'>
          <el-form-item label="备注：">
            {{
            params.ocbMark  || '--'
            }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'

export default {
  data () {
    return {
      params: {}
    }
  },
  methods: {
    onInitial (val) {
      this.params = val
      console.log(this.params)
      this.$emit('supplierContractNumber', this.params.supplierContractNumber)
    },
    supplierContractNumber () {
      this.$emit('supplierContractNumber', this.params.supplierContractNumber)
    },
    suIdClick (spId) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: spId }
      })
    }
  },
  filters: {
    dateFilterl,
    dateFilterDate,
    contractState (value) {
      // 1待审核,2审核中,3履行中,4已履行,5待签署 6已作废 7合同审核不通过 8盖章审核驳回 9盖章审核
      switch (value) {
        case 1:
          return '待审核'
        case 2:
          return '审核中'
        case 3:
          return '履行中'
        case 4:
          return '已履行'
        case 5:
          return '待签署'
        case 6:
          return '已作废'
        case 7:
          return '合同审核不通过'
        case 8:
          return '盖章审核驳回'
        case 9:
          return '盖章审核'
      }
    }
  }
}

function dateFilterl (time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}

function dateFilterDate (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
</script>
<style>
  .el-form-item--mini.el-form-item {
    margin-bottom: 10px;
  }
</style>
